import type { CaseListItem, CaseStatus } from "./case";
import { needsClientSideStatusFilter } from "./to-spiff-statuses";

export type RefineConditions = {
  readonly statuses: readonly CaseStatus[];
};

export type RefinedCases = {
  readonly items: readonly CaseListItem[];
  /**
   * API の総数が実件数と合わないか。
   *
   * 取得後に絞り込んだ場合、API に渡した条件は粗い（またはキーワードを渡していない）
   * ので pagination.total は実件数より多い。そのまま「全 n 件」と出すと嘘になる。
   */
  readonly isApproximateTotal: boolean;
};

/**
 * 取得した一覧をステータスで絞り直す。
 *
 * draft / inProgress は同じ生ステータス（非終了）に、returned / completed は同じ
 * `complete` に落ちるため、API だけでは相手を除けない。判別に必要な情報
 * （現在タスク名・判定 metadata）は行に載っているので変換後の status で絞る。
 *
 * 件名（キーワード）は API 側で絞る（全件が対象になる）。ここでは扱わない。
 *
 * これは取得済みのページ内での絞り込みになる（横断で正確に絞るには backend 側の
 * 対応が必要）。
 */
export function refineCases(
  items: readonly CaseListItem[],
  conditions: RefineConditions,
): RefinedCases {
  if (!needsClientSideStatusFilter(conditions.statuses)) {
    return { items, isApproximateTotal: false };
  }

  return {
    items: items.filter((item) => conditions.statuses.includes(item.status)),
    isApproximateTotal: true,
  };
}
